import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';

import { AI_GENERATE_BUTTON_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { FourPointedStarIcon } from 'src/app/v1/views/shared/Icons/FourPointedStarIcon';

import translations from './.vocab';

import * as styles from './index.css';

interface Props {
  onWriteWithAIClick: () => void;
}

export const WriteWithAICtaSection = ({ onWriteWithAIClick }: Props) => {
  const { t } = useTranslations(translations);

  const handleOnClick = () => {
    getTrackingAdapter.sendLinkEvent({
      eventName: AI_GENERATE_BUTTON_PRESSED,
    });

    onWriteWithAIClick();
  };

  return (
    <Box
      className={styles.layout}
      display="flex"
      alignItems="center"
      borderRadius="large"
      justifyContent="spaceBetween"
      padding="medium"
      position="relative"
      width="full"
    >
      <Text>{t('write-with-AI-cta-section-info-text')}</Text>
      <Box
        component="button"
        className={styles.writeWithAIButton}
        type="button"
        cursor="pointer"
        borderRadius="standard"
        display="flex"
        alignItems="center"
        justifyContent="center"
        marginLeft="gutter"
        paddingX="medium"
        onClick={handleOnClick}
        data-testid="ai-generation-cta"
      >
        <FourPointedStarIcon />
        <Text maxLines={1}>
          <Box component="span" className={styles.writeWithAIButtonText}>
            {t('write-with-AI-cta-section-write-with-ai-button-text')}
          </Box>
        </Text>
      </Box>
    </Box>
  );
};
